import React, { useEffect } from "react";

import {
    ReactFlow,
    Controls,
    Node,
    useReactFlow,
    Background,
    applyNodeChanges,
    applyEdgeChanges,
} from "@xyflow/react";
import "@xyflow/react/dist/style.css";

import { Button } from "../../../../src/Components/ui/button.tsx";
import { CustomNode } from "../components/CustomNode.tsx";

import { UNSELECTABLE_FIELD_KINDS } from "../constants/logic.ts";

import { TimerReset } from "lucide-react";
import { useLogicV2 } from "../hooks/use-logic-v2.ts";
import { useFormEditorContext } from "../../../Contexts/FormEditorContext.jsx";
import { ActionType } from "../types/zustand.ts";

const snapGrid: [number, number] = [16, 16];
const nodeTypes = {
    customNode: CustomNode,
};

export function Flow() {
    const flow = useReactFlow();
    const { nodes, edges, setNodes, setEdges, dispatch } = useLogicV2();
    const { fields, setSelectedField, editorField } = useFormEditorContext();

    useEffect(() => {
        const selectedNode = nodes.find((node) => node?.id === editorField?.id);
        if (selectedNode) {
            setTimeout(() => {
                flow.setCenter(
                    selectedNode.position.x,
                    selectedNode.position.y,
                    {
                        duration: 500,
                        zoom: 1.2,
                    },
                );
            }, 100);
        }
    }, [nodes, editorField]);

    const handleNodeClick = (_: unknown, node: Node) => {
        const { fieldId, type } = node.data as any;

        if (UNSELECTABLE_FIELD_KINDS.includes(type)) return;

        setSelectedField(fields.find((field) => field.id === fieldId));
    };

    const handleReset = () => {
        dispatch({
            type: ActionType.RESET_LOGIC,
            payload: {},
        });
    };

    return (
        <ReactFlow
            nodeTypes={nodeTypes as any}
            nodes={nodes}
            edges={edges}
            snapGrid={snapGrid}
            snapToGrid={true}
            onNodesChange={(changes) => {
                setNodes(applyNodeChanges(changes, nodes));
            }}
            onEdgesChange={(changes) => {
                setEdges(applyEdgeChanges(changes, edges));
            }}
            onNodeClick={handleNodeClick}
            proOptions={{
                hideAttribution: true,
            }}
            zoomOnPinch={true}
        >
            <Controls showInteractive={false} orientation="horizontal">
                <Button
                    onClick={handleReset}
                    className="z-50 bg-white w-[25px] h-[25px] rounded-none hover:bg-zinc-100"
                    variant="ghost"
                    size="icon"
                >
                    <TimerReset className="w-5 h-5 pb-0.5" />
                </Button>
            </Controls>
            <Background bgColor="#F7F8F9" />
        </ReactFlow>
    );
}
